import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download_staging/6a2073862900fb00147a1b7f_1780667287178_03625416/printeasyshefali/node_modules/next/dist/client/app-dir/link.js");
